import { fixedDigitsValue } from "helpers/dataHelpers";
import { CheckCircleIcon, CurrencyIcon } from "icons";
import { FlexContainer } from "styled/Box";
import { LoyaltyBonus } from "types/loyalty";

export const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Goal level points",
    dataIndex: "goalLevelPoints",
    key: "goalLevelPoints",
    render: (value: number) => value || 0,
  },
  {
    title: "Users count",
    dataIndex: "usersCount",
    key: "usersCount",
    render: (value?: number) => value || 0,
  },
  {
    title: "Points per 1 KD",
    dataIndex: "pointsAmountForOrder",
    key: "pointsAmountForOrder",
    render: (value: number) => value || 0,
  },
  {
    title: "Maintain amount",
    dataIndex: "maintainAmount",
    key: "maintainAmount",
    render: (value: number) => value || 0,
  },
  {
    title: "Discount percentage",
    dataIndex: "discountPercentage",
    key: "discountPercentage",
    render: (value: number) => `${value || 0}%`,
  },
  {
    title: "Free delivery days",
    dataIndex: "freeDeliveryDays",
    key: "freeDeliveryDays",
    render: (value: number) => value || 0,
  },
  {
    title: "Birthday bonus (FM Coins)",
    dataIndex: "birthdayGift",
    key: "birthdayGift",
    align: "center" as const,
    render: (value: number) => (
      <FlexContainer $align="center" $justify="center" $gap={8}>
        {fixedDigitsValue(Number(value), 3)} <CurrencyIcon />
      </FlexContainer>
    ),
  },
  {
    title: "Welcome bonus (FM Coins)",
    dataIndex: "welcomeBonus",
    key: "welcomeBonus",
    align: "center" as const,
    render: (value: number) => (
      <FlexContainer $align="center" $justify="center" $gap={8}>
        {fixedDigitsValue(Number(value), 3)} <CurrencyIcon />
      </FlexContainer>
    ),
  },
  {
    title: "Healthy perk",
    dataIndex: "healthyPerkAvailable",
    key: "healthyPerkAvailable",
    align: "center" as const,
    render: (vipCategoryAvailable: boolean) =>
      vipCategoryAvailable ? <CheckCircleIcon /> : null,
  },
  {
    title: "Vip category",
    dataIndex: "vipCategoryAvailable",
    key: "vipCategoryAvailable",
    align: "center" as const,
    render: (vipCategoryAvailable: boolean) =>
      vipCategoryAvailable ? <CheckCircleIcon /> : null,
  },
  {
    title: "AI features",
    dataIndex: "aiAssistantAvailable",
    key: "aiAssistantAvailable",
    align: "center" as const,
    render: (aiAssistantAvailable: boolean) =>
      aiAssistantAvailable ? <CheckCircleIcon /> : null,
  },
  {
    title: "Free items",
    dataIndex: "bonus",
    key: "bonus",
    align: "right" as const,
    render: (bonus: LoyaltyBonus) => bonus?.title || "",
  },
];
